import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Row, Col, Form, Input, Select, message, DatePicker, Table, Spin, Space, Drawer, Modal } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { pdf, PDFViewer } from '@react-pdf/renderer'
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import { getContactDatabyAccount, QuotesItemListColumn, getDealDatabyAccount } from './Functions/quotesFunctions';
import QuotationPdf from './PdfComponents/InvoicePdf';
import { THEMES } from './PdfComponents/pdfCommon';
import CustomInvoiceBuilder from './PdfComponents/InvoiceCustomTable'
import DetailsPage from '../Pages/DetailsPage/Detailspage';
import QuotesFields from '../Pages/DetailsPage/InvoiceFields'
import QuotesRight from '../Pages/DetailsPage/InvoiceRight'
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { FetchContactDetails, FetchContactByAccount, FetchContactByDeal } from '../../../Api/Services/ContactApiService'
import { FetchDealByAccount } from '../../../Api/Services/DealApiService'
import { getCompanyInvoice, findOneByInvoice, deleteInvoice, updateInvoice, createInvoice } from '../../../Api/Services/InvoiceApiServiec'
import { FetchAllAccount, FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { fetchFileAsBufferFile, getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { CompanyDataByUser } from '../../../Api/Services/CompanyApiService'
import { FetchSalesOrderDetails, FetchAllSalesOrder, } from '../../../Api/Services/SalesOrderApiService'
import { FetchAllQuotes, FetchQuoteDetails } from '../../../Api/Services/QuotesApiService'
import { AddUser } from '../style';
import { setEditCall, setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
// import { PageHeader } from '../../../components/page-headers/page-headers';
// import { Cards } from '../../../components/cards/frame/cards-frame';
import ComposeMail from '../Email/QSICompose';
import { ExchangeCurrency, convertCurrency, useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper, OrderSummary, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import AddressPopup from '../Popup/AddressPopup'
import { EmailIcon, PdfDownloadIcon, QUSOINIcon, DeleteIcon, SaveIcon, CancelIcon, EditIcon } from '../../../components/Icons/Icons';
import { validateShortText } from '../../../components/utilities/utilities';

const { Option } = Select;

const schema = [
    {
        id: "item",
        fieldId: "A1",
        title: "Item",
        type: "text",
        formulaType: "",
        formula: "",
        width: 260,
        hidden: false,

    },
    {
        id: "qty",
        fieldId: "B1",
        title: "Qty",
        type: "number",
        formulaType: "",
        formula: "",
        width: 120,
        hidden: false,
        isHide: true,
        isEditable: true,
    },
    {
        id: "price",
        fieldId: "C1",
        title: "Price",
        type: "currency",
        formulaType: "",
        formula: "",
        width: 160,
        hidden: false,
        isHide: true,
        isEditable: true,
    },
    {
        id: "total",
        fieldId: "D1",
        title: "Total",
        type: "formula",
        formulaType: "currency",
        formula: "B1 * C1",
        width: 180,
        hidden: false,
        isHide: true,
    },
]
const schemaHeadr = [{ item: "", qty: 1, price: 0, total: 0 }];

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, ShortCut, cloneId, setCloneId }) {
    const scrollRef = useRef(null);
    const getFieldPopupContainer = (triggerNode) =>
        scrollRef.current?.view ||
        triggerNode.closest('.ant-drawer-content') ||
        triggerNode.closest('.ant-modal-content') ||
        document.body;
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const { emailactiontype } = useSelector((state) => state.EmailData);
    const InvoiceDeLocalData = useSelector((state) => state.localRedux);
    const Role = InvoiceDeLocalData.role
    const defaultCurrency = InvoiceDeLocalData.currency
    const ProfileData = InvoiceDeLocalData.profile
    const profile = ProfileData
    const dispatch = useDispatch();
    const [pages] = useState("Meeting")
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDatess = new Date(currentrealTime);
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const history = useHistory();
    const [form] = Form.useForm();
    const [items, setItems] = useState([])
    const [users, setUsers] = useState([])
    const [deal, setDeal] = useState([])
    const [content1, setContent1] = React.useState();
    const [content2, setContent2] = React.useState();
    const [content3, setContent3] = React.useState();
    const [FILEList, setFileList] = useState([]);
    const [account, setAccount] = useState([])
    const [contact, setContact] = useState([])
    const [edit, setEdit] = useState(false)
    const [allList, setAllList] = useState([])
    const [mailOpen, setMailOpen] = useState(false)
    const [companyData, setCompanyData] = useState()
    const [invoiceId, setInvoiceId] = useState()
    const [displayData, setDisplayData] = useState()
    const [QuotesData, setQuotesData] = useState([])
    const [salesOrder, setSalesOrder] = useState([])
    const [conatactDetails, setConatactDetails] = useState()
    const [InvoiceStatus, setInvoiceStatus] = useState()
    const [paymentStatus, setPaymentStatus] = useState()
    const [DueDate, setDueDate] = useState(null)
    const [InvoiceDate, setInvoiceDate] = useState(null)
    const [billingAddress, setBillingAddress] = useState({})
    const [shipingAddress, setShipingAddress] = useState({})
    const [accountId, setAccountId] = useState(null)
    const [popupOpen, setPopupOpen] = useState(false)
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [dealDiscount, setDealDiscount] = useState()
    const [ProductColumns, setProductColumns] = useState([])
    const [accountJsonData, setAccountJsonData] = useState()
    const [total, setTotal] = useState()
    const [dealType, setDealType] = useState()
    const [grandTotal, setGrandTotal] = useState()
    const [tax, setTax] = useState()
    const [errorData, setErrorData] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [editField, setEditField] = useState(false)
    const [adjustment, setAdjustment] = useState()
    const [deleteId, setDeleteId] = useState()
    const [popupType, setPopupType] = useState()
    const [popupMessage, setPopupMessage] = useState(false)
    const [popupContent, setPopupContent] = useState()
    const [tableItems, setTableItems] = useState()
    const [shippingss, setShipping] = useState(0)
    const [attachFile, setAttachFile] = useState()
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const [errors, setErrors] = useState({});
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [ownInvoice, setOwnInvoice] = useState()
    const [ownInvoice2, setOwnInvoice2] = useState()
    const [itemTableHeader, setItemTableHeader] = useState()
    const Billing = Object.entries(billingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const Shipping = Object.entries(shipingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const isCustomMode =
        ownInvoice === "Not Applicable" &&
        ownInvoice2 === "Not Applicable";
    const validateDate = (date, index, fieldName) => {
        const errorKey = `${fieldName}-${index}`;
        if (!date) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [errorKey]: true
            }));
        } else {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[errorKey];
                return newErrors;
            });
        }
    };
    const isObject = (obj) => obj && typeof obj === "object";
    const normalizeForComparison = (val1, val2) => {
        // If payload value (val1) is a number, try converting displayData value (val2) to number
        if (typeof val1 === "number") {
            const num2 = Number(val2);
            return [val1, Number.isNaN(num2) ? val2 : num2]; // ✅ replaced isNaN with Number.isNaN
        }

        // If payload value is a numeric string and displayData is number → convert payload to number
        if (typeof val1 === "string" && val1.trim() !== "" && !Number.isNaN(Number(val1)) && typeof val2 === "number") {
            return [Number(val1), val2]; // ✅ also using Number.isNaN here
        }

        // Otherwise, return as-is
        return [val1, val2];
    };
    const PageCancel = () => {
        dispatch(setEditCall(false))
        history.push('/Home/invoices')
    }
    const deepEqual = (obj1, obj2, ignoreKeys = []) => {
        // ✅ CHANGED: added normalization step for non-object values
        if (!isObject(obj1) || !isObject(obj2)) {
            const [val1, val2] = normalizeForComparison(obj1, obj2);
            return val1 === val2;
        }

        // Handle arrays (same as before)
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            return obj1.every((item, i) => deepEqual(item, obj2[i], ignoreKeys));
        }

        // Handle objects (same as before)
        const keys1 = Object.keys(obj1).filter((k) => !ignoreKeys.includes(k));
        const keys2 = Object.keys(obj2).filter((k) => !ignoreKeys.includes(k));

        if (keys1.length !== keys2.length) return false;

        return keys1.every(
            (key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key], ignoreKeys)
        );
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return response;
        }
        catch (error) {
            message.error(error)
        }
    }
    // const getDaysBetween = (startDate, endDate) => {
    //     const start = new Date(startDate);
    //     const end = new Date(endDate);
    //     const timeDifference = end - start;
    //     const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    //     return daysDifference;
    // };
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!/[A-Za-z0-9]/.test(value)) {
            return Promise.reject(
                new Error("Invoice number cannot contain only hyphens")
            );
        }
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Invoice number cannot exceed 15 characters")
            );
        }
        const getList = allList
            .filter(item => item.invoiceId !== invoiceId)
        const existingCodes = getList.map(item => item.invoiceNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    async function getAccountData(params) {
        if (params) {
            try {
                const responseData = await FetchAccountDetails(params)
                const Response = responseData.data
                setAccountJsonData(Response)
            } catch (error) {
                message.error(error)
            }
        }
    }
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.invoiceNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyInvoice()
            if (type === "Create") {
                const newCode = generateUniqueCode("INV", data);
                form.setFieldsValue({
                    number: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const DueDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDueDate(formattedDate);
    };
    const invoiceDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setInvoiceDate(formattedDate);
    };
    const onnavigate = () => {
        dispatch(setEditCall(false))
        history.push("/Home/email-config")
    }
    function totalCalculation() {
        let subtotal = 0;
        let discountedTotal = 0;
        let taxTotal = 0;
        let grandTotal = 0;
        const isValidNumber = (val) => val !== "0" && val !== 0 && val !== "" && val !== null && val !== undefined;
        if (items?.length > 0) {
            for (let i = 0; i < items?.length; i += 1) {
                if (items[i].total) {
                    subtotal += Number(items[i].total);
                }
            }
        }
        if (isValidNumber(dealDiscount)) {
            discountedTotal = subtotal * (1 - Number(dealDiscount) / 100);
        } else {
            discountedTotal = subtotal;
        }
        if (isValidNumber(tax)) {
            taxTotal = discountedTotal * (1 + Number(tax) / 100);
        } else {
            taxTotal = discountedTotal;
        }

        grandTotal = taxTotal;

        if (isValidNumber(adjustment)) {
            grandTotal -= Number(adjustment);
        }

        if (isValidNumber(shippingss)) {
            grandTotal += Number(shippingss);
        }
        setTotal(subtotal?.toFixed(CurencyDecimalPlace));
        setGrandTotal(grandTotal?.toFixed(CurencyDecimalPlace));
    }
    const removeItem = (index, data) => {
        const updatedFormData = [...data];
        updatedFormData.splice(index, 1);
        setItems(updatedFormData);
    }
    const handleTableItem = async (index, fieldName, value, data, type, id) => {
        const updatedFormData = [...data];
        if (fieldName === "startDate" || fieldName === "endDate") {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
            };
        }
        const Cost = parseFloat(updatedFormData[index].value || 0);
        if (type === "StaffAug") {
            let totalBusinessDays = 0;
            if (id && updatedFormData[index].startDate && updatedFormData[index].endDate) {
                totalBusinessDays = await getWorkingDays(id, updatedFormData[index].startDate, updatedFormData[index].endDate);
            } if (Cost > 0 && totalBusinessDays > 0) {
                const totalValue = Cost * totalBusinessDays
                updatedFormData[index].total = totalValue?.toFixed(CurencyDecimalPlace)
            }
            else {
                updatedFormData[index].total = 0
            }
        }
        if (type === "Product") {
            const numberOfUnits = parseFloat(updatedFormData[index].qty || 0);
            const licenseDuration = parseFloat(updatedFormData[index].duration || 0);
            if (Cost > 0 && numberOfUnits > 0 && licenseDuration > 0) {
                const totalValue = Cost * numberOfUnits * licenseDuration
                updatedFormData[index].total = totalValue?.toFixed(CurencyDecimalPlace)
            } else {
                updatedFormData[index].total = 0
            }
        }
        if (type === "Others" || type === "RFP" || type === "Service") {
            updatedFormData[index].total = Cost
        }
        setItems(updatedFormData);
    };
    async function getContactDe(value) {
        if (value.conatctId) {
            try {
                const responseData = await FetchContactDetails(value.conatctId)
                const contactDetailsDataQ = responseData.data
                setConatactDetails(contactDetailsDataQ)
            } catch (error) {
                setConatactDetails()
                message.error(error)
            }
        }
    }
    const setData = async (value) => {
        if (value) {
            setInvoiceId(value.invoiceId)
            setPaymentStatus(value.paymentStatus)
            const salesCommision = value.salesCommision
                ? await ExchangeCurrency(Number(value.salesCommision), ConvertRate)
                : value.salesCommision;
            const exciseDuty = value.exciseDuty
                ? await ExchangeCurrency(Number(value.exciseDuty), ConvertRate)
                : value.exciseDuty;
            const paidAmountDuty = value.paidAmount
                ? await ExchangeCurrency(Number(value.paidAmount), ConvertRate)
                : value.paidAmount;
            const balanceAmountDuty = value.balanceAmount
                ? await ExchangeCurrency(Number(value.balanceAmount), ConvertRate)
                : value.balanceAmount;
            setInvoiceStatus(value.invoiceStatus)
            setAccountId(value.accountId)
            setBillingAddress(value.billingAddress)
            setShipingAddress(value.shippingAddress)
            setDueDate(value.dueDate)
            setInvoiceDate(value.invoiceDate)
            const subtotal = value.invoiceItem?.subtotalamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.subtotalamount), ConvertRate)
                : value.invoiceItem.subtotalamount;
            const total = value.invoiceItem?.grandTotalamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.grandTotalamount), ConvertRate)
                : value.invoiceItem.grandTotalamount;
            const adjustent = value.invoiceItem?.adjustmentAmount
                ? await ExchangeCurrency(Number(value.invoiceItem?.adjustmentAmount), ConvertRate)
                : value.invoiceItem?.adjustmentAmount;
            const shipppingdatra = value.invoiceItem?.shippingamount
                ? await ExchangeCurrency(Number(value.invoiceItem?.shippingamount), ConvertRate)
                : value.invoiceItem?.shippingamount;
            setDealDiscount(value.invoiceItem?.discountamount)
            setTotal(subtotal)
            setGrandTotal(total)
            setTax(value.invoiceItem?.taxAmount)
            setDealType(value.invoiceItem?.dealData)
            setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
            setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
            const convertedRoleData = (value.salesOrderId || value.quoteId) ? await Promise.all(
                value.invoiceItem?.item.map(async (role) => {
                    const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                        ? ExchangeCurrency(Number(role.value), ConvertRate)
                        : role.value);
                    const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                        ? ExchangeCurrency(Number(role.total), ConvertRate)
                        : role.total);
                    return {
                        ...role,
                        value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            ) : await Promise.all(
                value.invoiceItem?.item.map(async (row) => {
                    const updatedRow = { ...row };
                    await Promise.all(
                        value?.tableheaders.map(async (col) => {
                            const isCurrencyColumn =
                                col.type === "currency" ||
                                (
                                    col.type === "formula" &&
                                    col.formulaType === "currency"
                                );
                            if (!isCurrencyColumn) return;
                            const value = row[col.id];
                            if (
                                value !== undefined &&
                                value !== null &&
                                value !== ""
                            ) {
                                updatedRow[col.id] =
                                    await convertCurrency(
                                        ConvertRate,
                                        Number(value)
                                    );
                            }
                        })
                    );
                    return updatedRow;
                })
            )
            setOwnInvoice(value.salesOrderId || "Not Applicable")
            setOwnInvoice2(value.quoteId || "Not Applicable")
            setItems(convertedRoleData)
            setItemTableHeader(value?.tableheaders || schema);
            // const QuotesItemArrayColumn = await QuotesItemListColumn(value.invoiceItem?.dealData, profile, disabledDate, defaultCurrency, "Invoice", items, removeItem, handleTableItem);
            // setProductColumns(QuotesItemArrayColumn)
            setTableItems(value.invoiceItem?.dealData)
            setFileList(value.uploadFile || [])
            const updateData = {
                ...value,
                exciseDuty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                salesCommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                paidAmount: paidAmountDuty && paidAmountDuty !== "" ? Number(paidAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                balanceAmount: balanceAmountDuty && balanceAmountDuty !== "" ? Number(balanceAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
            }
            setDisplayData(updateData)
            getContactDe(value)
            if (FromPage === "EntityUpdate") {
                form.setFieldsValue({
                    number: value.invoiceNumber,
                })
            }
            form.setFieldsValue({
                balanceAmount: balanceAmountDuty && balanceAmountDuty !== "" ? Number(balanceAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                paidAmount: paidAmountDuty && paidAmountDuty !== "" ? Number(paidAmountDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                paymentStatus: value.paymentStatus,
                subject: value.invoiceName,
                InOwner: value.invoiceOwner,
                sonumber: value.salesOrderId || "Not Applicable",
                prnumber: value.purchaseOrderNumber,
                qnumber: value.quoteId || "Not Applicable",
                status: value.invoiceStatus,
                deal: value.dealId,
                account: value.accountId,
                exciseduty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                salescommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                contact: value.conatctId,
                // description: value.description,
                // notes: value.notes,
                // termsandCondition: value.termsAndCondition,
                invoicedate: value.invoiceDate === "" || value.invoiceDate === null ? null :
                    moment(formatDateString(value.invoiceDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                date: value.dueDate === "" || value.dueDate === null ? null :
                    moment(formatDateString(value.dueDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
            })
            setContent1(value.termsAndCondition)
            setContent2(value.description)
            setContent3(value.notes)
        }
    }
    const fetchAll3 = async (data) => {
        await Promise.allSettled([
            setData(data),
            getAccountData(data?.accountId),
        ])
    };
    async function getAccoutList(value) {
        if (value.accountId) {
            try {
                const contactArray = await getDealDatabyAccount(value.accountId, value.dealId)
                setDeal(contactArray)
            } catch (error) {
                setDeal([])
                message.error(error)
            }
        } else {
            setDeal([])
        }
    }
    async function getDealList(value) {
        if (value.dealId) {
            try {
                const contactArray = await getContactDatabyAccount(value.dealId, value.conatctId)
                setContact(contactArray)
            } catch (error) {
                setContact([])
                message.error(error)
            }
        } else {
            setContact([])
        }
    }
    async function getData(id) {
        let dataError = true;
        try {
            const response = await findOneByInvoice(id)
            dataError = response.allow
            if (!response.allow) throw new Error();
            fetchAll3(response.data);
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setPaymentStatus()
        form.setFieldsValue({
            balanceAmount: null,
            paidAmount: null,
            paymentStatus: null,
            subject: null,
            number: null,
            InOwner: null,
            sonumber: null,
            prnumber: null,
            qnumber: null,
            status: null,
            deal: null,
            account: null,
            exciseduty: null,
            salescommision: null,
            contact: null,
            // description: null,
            // termsandCondition: null,
            invoicedate: null,
            date: null
        })
        setContent1()
        setContent2()
        setContent3()
        setAccountJsonData()
        setInvoiceStatus()
        setAccountId()
        setBillingAddress({})
        setShipingAddress({})
        setDueDate()
        setInvoiceDate()
        setShipping(0)
        setDealDiscount()
        setTotal()
        setGrandTotal()
        setTax()
        setDealType()
        setAdjustment()
        setDeal([])
        setContact([])
        setItems([])
        setTableItems()
        setConatactDetails()
        setOwnInvoice()
        setOwnInvoice2()
        setItemTableHeader([])
        setFileList([])
        if (FromPage !== "EntityUpdate" && FromPage !== "FromSalesOR" && ShortCut !== "Shortcut") {
            GetAll();
            setCloneId()
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData1(id, hideMessage, updateResponse) {
        let dataError = true;
        try {
            const response = await findOneByInvoice(id)
            hideMessage()
            message.success(
                <span>
                    Invoice <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            dataError = response.allow
            if (!response.allow) throw new Error();
            fetchAll3(response.data);
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage()
            loadingRef.current = false;
            setDoubleClick(false)
            message.success(
                <span>
                    Invoice <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setInvoiceId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    // const fetchFileAsBuffer = async (url) => {
    //     try {
    //         const fileName = url.split('/').pop();
    //         const response = await fetchFileAsBufferFile(fileName)
    //         if (response && response.type === "Buffer" && Array.isArray(response.data)) {
    //             const uint8Array = new Uint8Array(response.data);
    //             const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), "");
    //             const base64String = btoa(binaryString);
    //             return `data:image/png;base64,${base64String}`;
    //         }
    //         return null;
    //     } catch (error) {
    //         message.error(error)
    //     }
    // };
    const fetchFileAsBuffer = async (url) => {
        try {
            const response = await fetchFileAsBufferFile(url);
            if (response && response.type === "Buffer" && Array.isArray(response.data)) {
                const uint8Array = new Uint8Array(response.data);
                // Create a Blob from the Uint8Array
                const blob = new Blob([uint8Array]);
                // Create a URL for the Blob (fastest, no base64 conversion needed)
                const objectUrl = URL.createObjectURL(blob);
                return objectUrl;
            }
            return null;
        } catch (error) {
            message.error(error)
            return null;
        }
    };
    const getImageDimensions = (url) =>
        new Promise((resolve) => {
            const img = new window.Image();
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };
            img.onerror = () => {
                resolve(null);
            };
            img.src = url;
        });

    const [pdfTheme, setPdfTheme] = useState('default');
    const handlePdfThemeChange = (value) => {
        setPdfTheme(value);
    };
    const getLogoBoxSize = (naturalWidth, naturalHeight) => {
        if (naturalWidth === naturalHeight) {
            return { width: 70, height: 70 };
        }
        return { width: 100, height: 70 };
    };
    async function getCompanyDetails() {
        try {
            const data = await CompanyDataByUser()
            const base64Image = await fetchFileAsBuffer(data.accountLogo);
            let logoSize = { width: 70, height: 70 };
            if (base64Image) {
                const dims = await getImageDimensions(base64Image);
                if (dims) {
                    logoSize = getLogoBoxSize(dims.width, dims.height);
                }
            }
            const changedData = { ...data, accountLogo: base64Image, logoSize };
            setCompanyData(changedData);
        } catch (error) {
            message.error(error);
        }
    }
    async function getAccount(value) {
        try {
            setAccountId(value)
            getAccountData(value)
            if (value) {
                const data = await FetchDealByAccount(value);
                const options = data.filter(option =>
                    ["Proposal", "Negotiation", "Won", "on-Hold", "On-Hold"].includes(option.pipelineStage)
                ).map((option, i) => (
                    <Option value={option.deals_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                        < img src={option.deal_profile} alt="profile" />
                                        :
                                        <span className="image_icon DealIcon">
                                            {option.deal_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                            <div>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                            </div>
                        </div>
                    </Option>));
                setDeal(options)
                form.setFieldsValue({
                    deal: undefined,
                    contact: undefined,
                })
                if (!isCustomMode) {
                    setItems([])
                }
                const response = await FetchContactByAccount(value)
                const options1 = response.map((option, i) => (
                    <Option value={option.contacts_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" />
                                        :
                                        <span className="image_icon ContactIcon">
                                            {option.first_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                </div>
                            </div>
                        </div>)} >
                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                            <div>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                <p style={{ margin: 0 }}>{option.email}</p>
                            </div>
                        </div>
                    </Option>))
                setContact(options1)
            } else {
                if (!isCustomMode) {
                    setItems([])
                }
                setDeal([])
                setContact([])
                form.setFieldsValue({
                    deal: undefined,
                    contact: undefined,
                })
            }
        }
        catch (error) {
            message.error(error);
        }
    }
    async function getDeal(value) {
        form.setFieldsValue({ deal: value || null })
        try {
            if (value) {
                const data = await FetchContactByDeal(value)
                const options = data.map((option, i) => (
                    <Option value={option.contacts_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" />
                                        :
                                        <span className="image_icon ContactIcon">
                                            {option.first_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                </div>
                            </div>
                        </div>)} >
                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                            <div>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                <p style={{ margin: 0 }}>{option.email}</p>
                            </div>
                        </div>
                    </Option>))
                setContact(options)
                form.setFieldsValue({
                    contact: undefined,
                })
                if (!isCustomMode) {
                    setItems([])
                }
            }
            else {
                setContact([])
                form.setFieldsValue({
                    contact: undefined,
                })
            }
        } catch (error) {
            message.error(error);
        }
    }
    async function getQuotesData(value) {
        if (value?.QuoteId !== "Not Applicable") {
            setItems([])
            let hideMessage;
            try {
                hideMessage = message.loading("Sync with quote...", 0);
                const response = await FetchQuoteDetails(value?.QuoteId);
                setAccountId(response.data.accountId)
                setBillingAddress(response.data.billingAddress)
                setShipingAddress(response.data.shippingAddress)
                const subtotal = response.data.quotesItem?.subtotalamount
                    ? await ExchangeCurrency(Number(response.data.quotesItem?.subtotalamount), ConvertRate)
                    : response.data.quotesItem.subtotalamount;
                const total = response.data.quotesItem?.grandTotalamount
                    ? await ExchangeCurrency(Number(response.data.quotesItem?.grandTotalamount), ConvertRate)
                    : response.data.quotesItem.grandTotalamount;
                const adjustent = response.data.quotesItem?.adjustmentAmount
                    ? await ExchangeCurrency(Number(response.data.quotesItem?.adjustmentAmount), ConvertRate)
                    : response.data.quotesItem?.adjustmentAmount;
                const shipppingdatra = response.data.quotesItem?.shippingamount
                    ? await ExchangeCurrency(Number(response.data.quotesItem?.shippingamount), ConvertRate)
                    : response.data.quotesItem?.shippingamount;
                setDealDiscount(response.data.quotesItem?.discountamount)
                setOwnInvoice2(response.data.quotesId)
                setTotal(subtotal)
                setGrandTotal(total)
                setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
                setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
                setTax(response.data.quotesItem?.taxAmount)
                setDealType(response.data.quotesItem?.dealData)
                const dealArray = response.data.accountId ? await getDealDatabyAccount(response.data.accountId, response.data.dealId) : [];
                setDeal(dealArray)
                const contactArray = response.data.dealId ? await getContactDatabyAccount(response.data.dealId, response.data.conatctId) : [];
                setContact(contactArray)
                const convertedRoleData = await Promise.all(
                    response.data.quotesItem?.item.map(async (role) => {
                        const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                            ? ExchangeCurrency(Number(role.value), ConvertRate)
                            : role.value);
                        const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                            ? ExchangeCurrency(Number(role.total), ConvertRate)
                            : role.total);
                        return {
                            ...role,
                            value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                            total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                        };
                    })
                );
                setItems(convertedRoleData)
                setTableItems(response.data.quotesItem?.dealData)
                const responseData = await FetchContactDetails(response.data.conatctId)
                const contactDetails = responseData.data
                setConatactDetails(contactDetails)
                form.setFieldsValue({
                    qnumber: response.data.quotesId,
                    contact: response.data.conatctId,
                    // description: response.data.description,
                    deal: response.data.dealId,
                    account: response.data.accountId,
                    // termsandCondition: response.data.termsAndCondition,
                })
                setContent1(response.data.termsAndCondition)
                setContent2(response.data.description)
                setContent3()
                getAccountData(response.data.accountId)
                hideMessage();
                message.success("Invoice updated with current quotes details");
            } catch (error) {
                hideMessage();
                message.error("Failed to sync with current quotes");
                // message.error(error)
            }
        } else {
            form.setFieldsValue({
                qnumber: value.QuoteId,
                deal: undefined,
                account: undefined,
                contact: undefined,
                // description: undefined,
                // termsandCondition: undefined,
            })
            setContent1()
            setContent2()
            setContent3()
            setAccountJsonData()
            setOwnInvoice2(value.QuoteId || "Not Applicable")
            setAccountId(null)
            setBillingAddress({})
            setShipingAddress({})
            setDealDiscount(0)
            setTotal(0)
            setGrandTotal(0)
            setTax(0)
            setDealType()
            setAdjustment(0)
            setShipping(0)
            setDeal([])
            setContact([])
            setItems(schemaHeadr)
            setItemTableHeader(schema)
            setTableItems()
            setConatactDetails()
        }
    }
    async function getSalesOrderData(value) {
        if (value.SalesORId !== "Not Applicable") {
            setItems([])
            let hideMessage;
            try {
                hideMessage = message.loading("Sync with sales order...", 0);
                const response = await FetchSalesOrderDetails(value?.SalesORId);
                const salesCommision = response.data.salesCommision
                    ? await ExchangeCurrency(Number(response.data.salesCommision), ConvertRate)
                    : response.data.salesCommision;
                const exciseDuty = response.data.exciseDuty
                    ? await ExchangeCurrency(Number(response.data.exciseDuty), ConvertRate)
                    : response.data.exciseDuty;
                setAccountId(response.data.accountId)
                setBillingAddress(response.data.billingAddress)
                setShipingAddress(response.data.shippingAddress)
                const subtotal = response.data.salesOrderItem?.subtotalamount
                    ? await ExchangeCurrency(Number(response.data.salesOrderItem?.subtotalamount), ConvertRate)
                    : response.data.salesOrderItem.subtotalamount;
                const total = response.data.salesOrderItem?.grandTotalamount
                    ? await ExchangeCurrency(Number(response.data.salesOrderItem?.grandTotalamount), ConvertRate)
                    : response.data.salesOrderItem.grandTotalamount;
                const adjustent = response.data.salesOrderItem?.adjustmentAmount
                    ? await ExchangeCurrency(Number(response.data.salesOrderItem?.adjustmentAmount), ConvertRate)
                    : response.data.salesOrderItem?.adjustmentAmount;
                const shipppingdatra = response.data.salesOrderItem?.shippingamount
                    ? await ExchangeCurrency(Number(response.data.salesOrderItem?.shippingamount), ConvertRate)
                    : response.data.salesOrderItem?.shippingamount;
                setOwnInvoice(response.data.salesOrderId)
                setOwnInvoice2(response.data.quoteId)
                setDealDiscount(response.data.salesOrderItem?.discountamount)
                setTotal(subtotal)
                setGrandTotal(total)
                setTax(response.data.salesOrderItem?.taxAmount)
                setDealType(response.data.salesOrderItem?.dealData)
                setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
                setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
                const dealArray = response.data.accountId ? await getDealDatabyAccount(response.data.accountId, response.data.dealId) : [];
                setDeal(dealArray)
                const contactArray = response.data.dealId ? await getContactDatabyAccount(response.data.dealId, response.data.conatctId) : [];
                setContact(contactArray)
                const convertedRoleData = await Promise.all(
                    response.data.salesOrderItem?.item.map(async (role) => {
                        const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                            ? ExchangeCurrency(Number(role.value), ConvertRate)
                            : role.value);
                        const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                            ? ExchangeCurrency(Number(role.total), ConvertRate)
                            : role.total);
                        return {
                            ...role,
                            value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                            total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                        };
                    })
                );
                setItems(convertedRoleData)
                // const QuotesItemArrayColumn = await QuotesItemListColumn(response.data.salesOrderItem?.dealData, profile, disabledDate, defaultCurrency, "Invoice", items, removeItem, handleTableItem);
                // setProductColumns(QuotesItemArrayColumn)
                setTableItems(response.data.salesOrderItem?.dealData)
                const responseData = await FetchContactDetails(response.data.conatctId)
                const contactDetailsData = responseData.data
                setConatactDetails(contactDetailsData)
                form.setFieldsValue({
                    sonumber: response.data.salesOrderId,
                    prnumber: response.data.purchaseOrderNumber,
                    qnumber: response.data.quoteId,
                    deal: response.data.dealId,
                    account: response.data.accountId,
                    exciseduty: exciseDuty && exciseDuty !== "" ? Number(exciseDuty?.toFixed(CurencyDecimalPlace)) : undefined,
                    salescommision: salesCommision && salesCommision !== "" ? Number(salesCommision?.toFixed(CurencyDecimalPlace)) : undefined,
                    contact: response.data.conatctId,
                    // description: response.data.description,
                    // termsandCondition: response.data.termsAndCondition,
                    // date: response.data.dueDate === "" || response.data.dueDate === null ? null :
                    //     moment(formatDateString(response.data.dueDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                })
                setContent1(response.data.termsAndCondition)
                setContent2(response.data.description)
                getAccountData(response.data.accountId)
                setContent3()
                hideMessage();
                message.success("Invoice updated with current sales order details");
            } catch (error) {
                message.error("Failed to sync with current sales order");
                hideMessage();
            }
        } else {
            form.setFieldsValue({
                sonumber: value.SalesORId,
                prnumber: undefined,
                qnumber: value.SalesORId,
                deal: undefined,
                account: undefined,
                exciseduty: undefined,
                salescommision: undefined,
                contact: undefined,
                // description: undefined,
                // termsandCondition: undefined,
            })
            setContent1()
            setContent2()
            setContent3()
            setAccountJsonData()
            setAccountId(null)
            setBillingAddress({})
            setShipingAddress({})
            setOwnInvoice(value.SalesORId)
            setOwnInvoice2(value.SalesORId || "Not Applicable")
            setItems(schemaHeadr)
            setItemTableHeader(schema)
            setDealDiscount(0)
            setTotal(0)
            setGrandTotal(0)
            setTax(0)
            setDealType()
            setAdjustment(0)
            setShipping(0)
            setDeal([])
            setContact([])
            setTableItems()
            setConatactDetails()
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) { message.error(error) }
    }
    async function GetSalesOrders() {
        try {
            const response = await FetchAllSalesOrder()
            let finalData = response || [];
            if (FromPage !== "FromSalesOR") {
                const dummyData = {
                    salesOrderId: "Not Applicable",
                    salesOrderName: "Not Applicable",
                    salesOrderNumber: "Not Applicable",
                    salesOrderStatus: "Delivered"
                };
                finalData = [dummyData, ...finalData];
            }
            setSalesOrder(finalData);
        } catch (error) { message.error(error) }
    }
    async function getAllQuotes() {
        try {
            const response = await FetchAllQuotes()
            let finalData = response || [];
            if (FromPage !== "FromSalesOR") {
                const dummyData = {
                    quotesId: "Not Applicable",
                    quotesName: "Not Applicable",
                    quotesNumber: "Not Applicable",
                    quotesStatus: "Delivered"
                };
                finalData = [dummyData, ...finalData];
            }
            setQuotesData(finalData)
        } catch (error) { message.error(error) }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.accountId) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.accountId);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.accountName, account_number: displayData?.accountNumber, account_id: displayData?.accountId, account_type_name: "Customer" }];
                }
            }
            const options = accountInfo.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccount(options)
        } catch (error) { message.error(error) }
    }
    async function onChangeContact(value) {
        form.setFieldsValue({ contact: value || null })
        try {
            if (value) {
                const responseData = await FetchContactDetails(value);
                const response = responseData
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
            }
            else {
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
            }
        } catch (error) {
            message.error(error)
        }
    }
    const addressPopup = (type, content) => {
        setPopupOpen(true)
        setPopupType(type)
        setPopupContent(content)
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    async function deleteMenu(id) {
        try {
            const Response = await deleteInvoice(id)
            if (Response.status === 200) {
                setConfirmPopup(false)
                message.success("Invoice deleted")
                dispatch(setEditCall(false));
                history.push('/Home/invoices')
            }
        } catch (error) { message.error(error) }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
        scroolup()
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getAccoutList(displayData),
            getAccountData(displayData?.accountId),
            getDealList(displayData),
            getAllQuotes(),
            GetSalesOrders(),
            UserDetailsApi(),
            AccountApi(),
        ])
        setUiReady(true)
    };
    const fetchAll2 = async (data) => {
        await Promise.allSettled([
            getSalesOrderData(data),
        ])
    };
    useEffect(() => {
        if (FromPage) {
            scroolup()
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        if (
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                if (defaultCurrency) {
                    getEntityAvalibitlity()
                    getCompanyDetails()
                    getList("Update")
                }
            } else {
                if (FromPage === "FromSalesOR") {
                    if (defaultCurrency) {
                        fetchAll2(dataForDeal)
                        form.setFieldsValue({
                            status: "Created",
                        })
                    }
                }
                else if (FromPage === "CloneLead") {
                    getData(cloneId)
                    getList("Create")
                }
                else {
                    form.setFieldsValue({
                        balanceAmount: undefined,
                        paidAmount: undefined,
                        paymentStatus: undefined,
                        subject: undefined,
                        number: undefined,
                        InOwner: undefined,
                        sonumber: "Not Applicable",
                        prnumber: undefined,
                        qnumber: "Not Applicable",
                        status: "Created",
                        deal: undefined,
                        account: undefined,
                        exciseduty: undefined,
                        salescommision: undefined,
                        contact: undefined,
                        // description: undefined,
                        // termsandCondition: undefined,
                        invoicedate: undefined,
                        date: undefined
                    })
                    setContent1()
                    setContent2()
                    setContent3()
                    setAccountJsonData()
                }
                setOwnInvoice("Not Applicable")
                setOwnInvoice2("Not Applicable")
                setItems(schemaHeadr)
                setItemTableHeader(schema)
                const getUserDetail = async () => {
                    if (UrlId === undefined || UrlId === null) {
                        if (profile.department === "Sales") {
                            form.setFieldsValue({
                                InOwner: profile.userId
                            });
                        }
                    }
                }
                form.setFieldsValue({
                    invoicedate: moment(currentDatess.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }))
                });
                getList("Create")
                setInvoiceDate(currentDatess.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }))
                getUserDetail()
                setEdit(true)
                setDisplayData("Create")
                setInvoiceId()
                setEditField(true)
            }
        }
    }, [UrlId, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [items, dealDiscount, tax, adjustment, shippingss, FromPage])
    useEffect(() => {
        if (FromPage && !isCustomMode) {
            const TableItemFucntion = async () => {
                const QuotesItemArrayColumn = await QuotesItemListColumn(tableItems, profile,
                    disabledDate, defaultCurrency, "Invoice", items,
                    removeItem, handleTableItem, errors, validateDate, true);
                setProductColumns(QuotesItemArrayColumn)
            }
            if (tableItems) {
                TableItemFucntion()
            }
        }
    }, [items, tableItems, FromPage, isCustomMode])
    const updateStatus1 = async (id) => {
        let hideMessage;
        try {
            hideMessage = message.loading("Updating status...", 0);
            const payload = {
                invoiceStatus: "Delivered",
            }
            const response = await updateInvoice(payload, id)
            if (response.status === 200) {
                dispatch(setEditCall(false))
                getData(invoiceId)
                hideMessage();
                scroolup()
            }
        }
        catch (error) {
            hideMessage();
            message.error(error);
        }
    }
    const updateStatus = (values) => {
        if (displayData?.invoiceStatus !== "Delivered") {
            const modal = Modal.confirm({
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                        <span> Change Status?</span>
                    </div>
                ),
                icon: null,
                content: (
                    <p>Would you like to update the status of this invoice to Delivered?</p>
                ),
                centered: true,
                className: "customice-confirm-modal",
                okText: "Yes",
                cancelText: "No",
                okButtonProps: {
                    className: "button_colorsModal"
                },
                cancelButtonProps: {
                    className: "gray-buttonModal"
                },
                okCancel: true,
                onOk() {
                    updateStatus1(values)
                },
                onCancel() {
                    modal.destroy();
                },
            });
        }
    };
    const buildPdfFileName = (companyName, code, date) => {
        const clean = (s) => String(s ?? "").replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, " ").trim();
        const profileFormat = profile?.dateFormate || "YYYY-MM-DD";
        const parsed = date ? moment(date, [profileFormat, moment.ISO_8601], true) : null;
        const datePart = parsed && parsed.isValid() ? parsed.format("DDMMYYYY") : "";
        return [clean(companyName), clean(code), datePart].filter(Boolean).join("_");
    };
    const handledownloadPdf = async () => {
        const blob = await pdf(
            <QuotationPdf data={displayData} profile={profile} accountJsonData={accountJsonData}
                companyData={companyData} tableItem={items} isCustomMode={isCustomMode} itemTableHeader={itemTableHeader}
                tableColum={isCustomMode ? itemTableHeader : ProductColumns.slice(0, -1)} currencySettings={defaultCurrency}
                Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
                theme={pdfTheme}
            />
        ).toBlob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${buildPdfFileName(companyData?.registeredName ? companyData?.registeredName : companyData?.companyName, displayData?.invoiceNumber, displayData?.dueDate)}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const CreateMail = async () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            const blob = await pdf(
                <QuotationPdf data={displayData} profile={profile} accountJsonData={accountJsonData}
                    companyData={companyData} tableItem={items} isCustomMode={isCustomMode} itemTableHeader={itemTableHeader}
                    tableColum={isCustomMode ? itemTableHeader : ProductColumns.slice(0, -1)} currencySettings={defaultCurrency}
                    Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
                    theme={pdfTheme}
                />
            ).toBlob();
            const arrayBuffer = await blob.arrayBuffer();
            const buffer = {
                filename: `${buildPdfFileName(companyData?.registeredName ? companyData?.registeredName : companyData?.companyName, displayData?.invoiceNumber, displayData?.dueDate)}.pdf`,
                contentType: "application/pdf",
                size: blob.size,
                contentDisposition: "attachment",
                content: {
                    type: "Buffer",
                    data: Array.from(new Uint8Array(arrayBuffer)),
                },
            };
            setAttachFile(buffer)
            setMailOpen(true)
        }
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    // const content = (
    //     <div style={{
    //         width: "100%",
    //         height: "100%",
    //     }}>
    //         <span role="button" className="text_icon moreLinks"
    //             tabIndex={0}
    //             onClick={edit ? () => { getSalesOrderData(displayData?.salesOrderId); setItems([]) } : undefined}
    //             onKeyDown={(event) => {
    //                 if (event.key === 'Enter' || event.key === ' ') {
    //                     getSalesOrderData(displayData?.salesOrderId);
    //                     setItems([])
    //                 }
    //             }}>
    //             <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Sales Order
    //         </span>
    //     </div >
    // );
    const SubjectData = `${companyData?.companyName} – Invoice for ${displayData?.invoiceName}`;
    // const MailContent = `<div> </div>
    // <div contenteditable='false' style="margin: 20px 0px 0px"> 
    const MailContent = `
        <div><br></div>
    <div style="margin: 20px 0px 0px">
    <div>Dear ${displayData?.contactFirstName},</div>
    <div>&nbsp;</div>
    <div dir="auto">Thank you for your business with ${companyData?.companyName}. Please find attached the invoice for your reference.</div>
    <div>&nbsp;</div>
    <div>Invoice Details:</div>
    <div>&bull; Invoice Number: ${displayData?.invoiceNumber}</div>
    <div>&bull; Invoice Date: ${displayData?.invoiceDate ? moment(displayData?.invoiceDate).format(profile.dateFormate) :
            (displayData?.invoiceDate && moment(displayData?.invoiceDate).format("YYYY-MM-DD"))}</div>
    <div>&bull; Due Date: ${displayData?.dueDate ? moment(displayData?.dueDate).format(profile.dateFormate) :
            (displayData?.dueDate && moment(displayData?.dueDate).format("YYYY-MM-DD"))}</div>
    <div>&bull; Total Amount: ${defaultCurrency?.symbol} ${Number(grandTotal)?.toLocaleString()}</div>
    <div>&nbsp;</div>
    <div>If you have any questions regarding this invoice, please feel free to contact us.</div>
    <div>&nbsp;</div>
     <div id = "signature-block-unique" contenteditable = "true" style = "margin-top: 20px;" >
            ${profile?.profileSignature || "<div>Add signature</div>"}
         </div >
    <div>&nbsp;</div>
    </div>`;
    const handlePaymentchange = (value) => {
        setPaymentStatus(value)
        if (value === "Fully Paid") {
            form.setFieldsValue({
                paidAmount: grandTotal,
                balanceAmount: 0,
            });
        }
        else {
            form.setFieldsValue({
                paidAmount: 0,
                balanceAmount: 0,
            });
        }
    }
    const handlePaidChange = (value) => {
        const numericValue = Number(value) || 0;
        const balanceAmount = parseFloat((grandTotal - numericValue)?.toFixed(defaultCurrency?.decimalOfCurrency));
        form.setFieldsValue({
            balanceAmount: balanceAmount >= 0 ? balanceAmount : 0,
        });
    };
    useEffect(() => {
        if (FromPage) {
            if (paymentStatus === "Fully Paid") {
                form.setFieldsValue({
                    paidAmount: grandTotal,
                    balanceAmount: 0,
                });
            }
            else {
                form.setFieldsValue({
                    paidAmount: 0,
                    balanceAmount: 0,
                });
            }
        }
    }, [grandTotal, FromPage])
    const handleEditChange = () => {
        setEditField(true)
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const ButtonActions = [
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Send Email'
                onClick={() => CreateMail()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Download PDF'
                onClick={() => handledownloadPdf()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        handledownloadPdf()
                    }
                }}
                aria-label='pdf'
            > <PdfDownloadIcon height={20} width={20} /></div>
        }
    ]
    const moreAction = "No"
    const MoreAction = () => (<></>)
    const LeadInfos = {
        profile: undefined,
        Classname: " ",
        letterIcon: displayData?.invoiceName,
        name: displayData?.invoiceName,
        subName: `${displayData?.invoiceNumber}`,
        mainAction: undefined,
    }
    const getDetailsDatas = useCallback(() => getData(invoiceId), [invoiceId]);
    const LeadDetails = (<QuotesFields pdfTheme={pdfTheme} Billing={Billing} onPdfThemeChange={handlePdfThemeChange} pdfThemes={THEMES} billingAddress={billingAddress} Shipping={Shipping} shipingAddress={shipingAddress} displayData={displayData} currencySettings={defaultCurrency} getDetailsData={getDetailsDatas} />);
    // Stable props so <PDFViewer> only regenerates the PDF when real data changes
    const pdfCalculation = useMemo(
        () => ({ total, dealDiscount, tax, adjustment, shippingss, grandTotal }),
        [total, dealDiscount, tax, adjustment, shippingss, grandTotal]
    );
    const pdfTableColumns = useMemo(
        () => (isCustomMode ? itemTableHeader : ProductColumns.slice(0, -1)),
        [isCustomMode, itemTableHeader, ProductColumns]
    );
    // Mount the viewer only after all data it needs has loaded (avoids render-per-prop during initial load)
    const pdfReady = Boolean(companyData && displayData && displayData !== "Create" && ownInvoice !== undefined && ownInvoice2 !== undefined && (!displayData?.accountId || accountJsonData) && (isCustomMode ? itemTableHeader?.length > 0 : ProductColumns.length > 0));
    const pdfDocument = useMemo(() => (pdfReady ? (
        <QuotationPdf data={displayData} accountJsonData={accountJsonData} profile={profile} companyData={companyData} tableItem={items} isCustomMode={isCustomMode} itemTableHeader={itemTableHeader} tableColum={pdfTableColumns} currencySettings={defaultCurrency} Calculation={pdfCalculation} theme={pdfTheme} />
    ) : null), [pdfReady, displayData, accountJsonData, profile, companyData, items, isCustomMode, itemTableHeader, pdfTableColumns, defaultCurrency, pdfCalculation, pdfTheme]);
    const RelatedDetails = (
        <div style={{ height: "100vh" }}>
            {pdfDocument ? (
                <PDFViewer width="100%" height="100%">
                    {pdfDocument}
                </PDFViewer>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Spin size="large" tip="Loading PDF..." />
                </div>
            )}
        </div>
    )
    const RightRelatedDetails = (<QuotesRight displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} currencySettings={defaultCurrency} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(invoiceId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate") {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    async function onSubmitApiCall(payload) {
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate") {
                const response = await updateInvoice(payload, invoiceId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const ownerChanged = displayData.invoiceOwner !== payload.invoiceOwner;
                        if (ownerChanged) {
                            hideMessage()
                            message.success(
                                <span>
                                    Invoice <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                            dispatch(setEditCall(false));
                            history.push('/Home/invoices')
                        }
                        else {
                            getData1(invoiceId, hideMessage, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createInvoice(payload)
                if (response.status === 201) {
                    hideMessage();
                    if (ShortCut === "Shortcut") {
                        dispatch(setEditCall(false))
                        history.push('/Home/invoices')
                    }
                    message.success("Invoice created")
                    if (FromPage === "FromSalesOR") {
                        dispatch(setEditCall(false))
                        history.push('/Home/invoices')
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error);
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span> Delivered State</span>
                </div>
            ),
            icon: null,
            className: "customice-confirm-modal",
            content: (
                <p>This invoice is marked as <strong>Delivered</strong>. Any changes will require sending a revised version to the customer. Do you wish to continue with the changes?</p>
            ),
            centered: true,
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "gray-buttonModal"
            },
            cancelButtonProps: {
                className: "button_colorsModal"
            },
            okCancel: true,
            onOk() {
                loadingRef.current = false;
                setDoubleClick(false)
                modal.destroy();
                setEdit(false)
                setEditField(false)
                dispatch(setEditCall(false));
                getData(invoiceId)
                scroolup()
                CloseDrawer()
            },
            onCancel() {
                onSubmitApiCall(values)
            },
        });
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        if (!Billing) {
            message.error("Please enter the billing address");
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        if (!Shipping) {
            message.error("Please enter the shipping address");
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        const { subject, number, InOwner, sonumber, prnumber, qnumber, balanceAmount, paidAmount, paymentStatus, status, deal, account, exciseduty, salescommision, contact } = values;
        const hasErrors = Object.values(errors).some(error => error === true);
        if (hasErrors) {
            message.error("Please fill out all required fields")
            scroolup()
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        const convertedData = isCustomMode ? await Promise.all(
            items.map(async (row) => {
                const updatedRow = { ...row };
                await Promise.all(
                    itemTableHeader.map(async (col) => {
                        const isCurrencyColumn =
                            col.type === "currency" ||
                            (
                                col.type === "formula" &&
                                col.formulaType === "currency"
                            );
                        if (!isCurrencyColumn) return;
                        const value = row[col.id];
                        if (
                            value !== undefined &&
                            value !== null &&
                            value !== ""
                        ) {
                            updatedRow[col.id] =
                                await convertCurrency(
                                    ConvertRate,
                                    Number(value)
                                );
                        }
                    })
                );
                return updatedRow;
            })
        ) : await Promise.all(
            items.map(async (role) => {
                const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                    ? convertCurrency(ConvertRate, Number(role.value))
                    : role.value);
                const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== "" ?
                    convertCurrency(ConvertRate, Number(role.total))
                    : role.total);
                return {
                    ...role,
                    value: convertedRate,
                    total: convertedTotalValue,
                };
            })
        );
        const SalesCommision = salescommision
            ? await convertCurrency(ConvertRate, Number(salescommision))
            : salescommision;
        const ExciseDuty = exciseduty
            ? await convertCurrency(ConvertRate, Number(exciseduty))
            : exciseduty;
        const subtotals = total ? await convertCurrency(ConvertRate, Number(total)) : total;
        const adjustments = adjustment ? await convertCurrency(ConvertRate, Number(adjustment)) : adjustment;
        const shippingssss = (shippingss && shippingss !== "") ? await convertCurrency(ConvertRate, Number(shippingss)) : 0;
        const totals = grandTotal ? await convertCurrency(ConvertRate, Number(grandTotal)) : grandTotal;
        const paidAmounttotals = paidAmount ? await convertCurrency(ConvertRate, Number(paidAmount)) : paidAmount;
        const balanceAmounttotals = balanceAmount ? await convertCurrency(ConvertRate, Number(balanceAmount)) : balanceAmount;
        const InvoiceItems = {
            item: convertedData,
            subtotalamount: normalizeValue(subtotals),
            discountamount: normalizeValue(dealDiscount),
            taxAmount: normalizeValue(tax),
            shippingamount: normalizeValue(shippingssss),
            adjustmentAmount: normalizeValue(adjustments),
            grandTotalamount: normalizeValue(totals),
            dealData: normalizeValue(dealType)
        }
        const payload =
        {
            invoiceName: normalizeValue(subject),
            invoiceNumber: normalizeValue(number),
            invoiceOwner: InOwner,
            salesOrderId: normalizeValue(sonumber === "Not Applicable" ? null : sonumber),
            purchaseOrderNumber: normalizeValue(prnumber),
            quoteId: normalizeValue(qnumber === "Not Applicable" ? null : qnumber),
            invoiceStatus: status,
            accountId: normalizeValue(account),
            dealId: normalizeValue(deal),
            conatctId: normalizeValue(contact),
            dueDate: normalizeValue(DueDate),
            invoiceDate: normalizeValue(InvoiceDate),
            salesCommision: normalizeValue(SalesCommision),
            exciseDuty: normalizeValue(ExciseDuty),
            billingAddress,
            shippingAddress: shipingAddress,
            invoiceItem: InvoiceItems,
            termsAndCondition: normalizeValue(content1),
            description: normalizeValue(content2),
            notes: normalizeValue(content3),
            grantTotal: normalizeValue(totals),
            paymentStatus: normalizeValue(InvoiceStatus === "Paid" ? paymentStatus : null),
            paidAmount: normalizeValue(InvoiceStatus === "Paid" ? paidAmounttotals : null),
            balanceAmount: normalizeValue(InvoiceStatus === "Paid" ? balanceAmounttotals : null),
            uploadFile: FILEList,
            tableheaders: isCustomMode ? itemTableHeader : null,
        }
        if (FromPage === "EntityUpdate") {
            if (displayData.invoiceStatus === "Delivered" && (payload.invoiceStatus !== "Created" && payload.invoiceStatus !== "Approved")) {
                const hasChanges = !deepEqual(displayData, payload, ["invoiceStatus"]);
                if (hasChanges) {
                    showConfirmForAccount(payload)
                }
                else {
                    onSubmitApiCall(payload)
                }
            }
            else {
                onSubmitApiCall(payload)
            }
        }
        else {
            onSubmitApiCall(payload)
        }
    }
    const getRefreshtheTable = () => {
        setEdit(false)
        setEditField(false)
        dispatch(setEditCall(false));
        getData(invoiceId)
        scroolup()
        CloseDrawer()
    }
    const handleChangestatus = (value) => {
        setInvoiceStatus(value)
        if (value === "Paid") {
            setPaymentStatus("Fully Paid")
            form.setFieldsValue({
                paymentStatus: "Fully Paid",
                paidAmount: grandTotal,
                balanceAmount: 0,
            });
        }
        else {
            setPaymentStatus()
            form.setFieldsValue({
                paymentStatus: null,
                paidAmount: null,
                balanceAmount: null
            });
        }
    }
    const onChangeNewTableData = (newData) => {
        setItems(newData?.rows);
        setItemTableHeader(newData?.schema);
    }
    const handleChange1 = (val) => {
        setContent1(val);
    };
    const handleChange2 = (val) => {
        setContent2(val);
    };
    const handleChange3 = (val) => {
        setContent3(val);
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        <span>
                            Update Invoice
                            {displayData?.invoiceName && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData?.invoiceName}
                                    </span>
                                </>
                            )}
                        </span>
                        : FromPage === "CloneLead" ? "Clone Invoice" : "Create Invoice"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (uiReady && edit) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" ?
                                <Button
                                    className="red-button" size="small"
                                    onClick={() => OnClickofDelete(invoiceId)}
                                >
                                    <DeleteIcon height={25} width={25} />Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(uiReady && displayData) ? <Scrollbars ref={scrollRef} autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                <Heading as="h5">Basic Information</Heading>
                                                                {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?INVOICE" && ownInvoice !== "Not Applicable") &&
                                                                    // <Dropdown placement="bottomLeft" size="small" content={content}>
                                                                    //     <FeatherIcon icon="more-vertical" size={25} style={{ marginTop: 6 }} />
                                                                    // </Dropdown>
                                                                    <div role="button" className="Hover-Refresh2 back-hover1 able-style" tabIndex={0}
                                                                        onClick={edit ? () => { getSalesOrderData({ SalesORId: displayData?.salesOrderId }); setItems([]) } : undefined}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                getSalesOrderData({ SalesORId: displayData?.salesOrderId });
                                                                                setItems([])
                                                                            }
                                                                        }}>
                                                                        <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Sales Order
                                                                    </div>
                                                                }
                                                            </div>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Name" name="subject" id="subject" rules={edit ? [{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter invoice name'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateShortText(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Invoice Name" /> :
                                                                            <span>{displayData?.invoiceName}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Number" name="number" id="number" rules={edit ? [{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter invoice number'
                                                                    }, { validator: validateCode }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Invoice Number" /> :
                                                                            <span>{displayData?.invoiceNumber}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Owner" name="InOwner" id="InOwner" rules={edit ? [{ required: true, message: 'Please select owner' }] : [{ required: false }]}>
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Invoice Owner"
                                                                            showSearch optionLabelProp="label"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {users}
                                                                        </Select> :
                                                                            <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.invoiceOwner && ViewDetailPage(displayData?.invoiceOwner, "USER")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.invoiceOwner, "USER");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.invoiceOwner && (
                                                                                displayData?.invoiceOwnerProfilePic !== null && displayData?.invoiceOwnerProfilePic
                                                                                    !== undefined && displayData?.invoiceOwnerProfilePic !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.invoiceOwnerProfilePic} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag UserIcon'>
                                                                                        {displayData?.invoiceOwnerFirstName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.invoiceOwner && (
                                                                                    <figcaption>
                                                                                        {`${displayData?.invoiceOwnerFirstName} ${displayData?.invoiceOwnerLastName}`}
                                                                                    </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Sales Order Number" name="sonumber" id="sonumber" rules={edit ? [{ required: true, message: 'Please enter sales order number' }] : [{ required: false }]}>
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} optionLabelProp="label" onChange={(value) => { getSalesOrderData({ SalesORId: value }) }} placeholder="Select Sales Order" showSearch optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {salesOrder?.filter(item => item.salesOrderStatus === "Delivered").map((option, i) => (
                                                                                <Option value={option.salesOrderId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.salesOrderName} ${option.salesOrderName !== "Not Applicable" ? `(${option.salesOrderNumber})` : ""}`} style={{ cursor: "default" }}>
                                                                                                <span className="image_icon">
                                                                                                    {option.salesOrderName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                                <span className='div-ellipsis'>{option.salesOrderNumber}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.salesOrderName} ${option.salesOrderName !== "Not Applicable" ? `(${option.salesOrderNumber})` : ""}`}>
                                                                                        <div>
                                                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.salesOrderName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.salesOrderNumber}</p>
                                                                                            <p style={{ margin: 0 }}>{option.salesOrderName !== "Not Applicable" ? option.salesOrderName : ""}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </Select> :
                                                                            <>{displayData?.salesOrderId ?
                                                                                <span className='user-info_image ListNavigate'
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    onClick={() => displayData?.salesOrderId && ViewDetailPage(displayData?.salesOrderId, "SORDER")}
                                                                                    onKeyDown={(event) => {
                                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                                            ViewDetailPage(displayData?.salesOrderId, "SORDER");
                                                                                        }
                                                                                    }}
                                                                                >{displayData?.salesOrderId &&
                                                                                    `${displayData?.salesOrderName} (${displayData?.salesOrderNumber})`}
                                                                                </span> : <></>}
                                                                            </>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Purchase Order Number" name="prnumber" id="prnumber" rules={edit ? [{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter purchase order number'
                                                                    }] : [{ required: false }]}>
                                                                        {edit ? <Input placeholder="Enter Purchase Order Number" disabled={ownInvoice !== "Not Applicable"} /> :
                                                                            <span>{displayData?.purchaseOrderNumber}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Quote Number" name="qnumber" id="qnumber" rules={edit ? [{ required: true, message: 'Please select quote number' }] : [{ required: false }]}>
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} optionLabelProp="label" disabled={ownInvoice !== "Not Applicable"}
                                                                            onChange={(value) => getQuotesData({ QuoteId: value })}
                                                                            placeholder="Select Quote Number"
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }>
                                                                            {QuotesData?.filter(item => item.quotesStatus === "Delivered").map((option, i) => (
                                                                                <Option value={option.quotesId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.quotesName} ${option.quotesName !== "Not Applicable" ? `(${option.quotesNumber})` : ""}`} style={{ cursor: "default" }}>
                                                                                                <span className="image_icon">
                                                                                                    {option.quotesName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                                <span className='div-ellipsis'>{option.quotesNumber}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.quotesName} ${option.quotesName !== "Not Applicable" ? `(${option.quotesNumber})` : ""}`}>
                                                                                        <div>
                                                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.quotesName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.quotesNumber}</p>
                                                                                            <p style={{ margin: 0 }}>{option.quotesName !== "Not Applicable" ? option.quotesName : ""}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </Select> :
                                                                            <>{displayData?.quoteId ? <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.quoteId && ViewDetailPage(displayData?.quoteId, "QUOTES")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.quoteId, "QUOTES");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.quoteId &&
                                                                                `${displayData?.quotesName} (${displayData?.quotesNumber})`}
                                                                            </span> : <></>}</>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Invoice Status" name="status" id="status" rules={edit ? [{ required: true, message: 'Please select status' }] : [{ required: false }]} >
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Enter Select Invoice Status" onChange={(value) => handleChangestatus(value)}>
                                                                            <Option value="Created">Created</Option>
                                                                            <Option value="Approved">Approved</Option>
                                                                            <Option value="Delivered">Delivered</Option>
                                                                            <Option value="Paid">Paid</Option>
                                                                            <Option value="Cancelled">Cancelled</Option>
                                                                        </Select> :
                                                                            <span>{displayData?.invoiceStatus}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Account Name" name="account" id="account" rules={edit ? [{ required: true, message: 'Please select account' }] : [{ required: false }]}>
                                                                        {edit ?
                                                                            <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                                placeholder="Select Account"
                                                                                showSearch disabled={ownInvoice !== "Not Applicable" || ownInvoice2 !== "Not Applicable"} optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                onChange={(value) => getAccount(value)}
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                            >
                                                                                {account}
                                                                            </Select>
                                                                            : <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.accountId && ViewDetailPage(displayData?.accountId, "ACCOUNT")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.accountId, "ACCOUNT");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.accountId && (
                                                                                displayData?.accountProfile !== null && displayData?.accountProfile
                                                                                    !== undefined && displayData?.accountProfile !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.accountProfile} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag AccountIcon'>
                                                                                        {displayData?.accountName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.accountId && (
                                                                                    <figcaption>
                                                                                        {displayData?.accountName} ({displayData?.accountNumber})
                                                                                    </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Deal Name" name="deal" id="deal" rules={(edit && !(ownInvoice === "Not Applicable" && ownInvoice2 === "Not Applicable")) ? [{ required: true, message: 'Please select deal' }] : [{ required: false }]}>
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Deal" onChange={(value) => getDeal(value)}
                                                                            showSearch optionLabelProp="label"
                                                                            disabled={ownInvoice !== "Not Applicable" || ownInvoice2 !== "Not Applicable"}
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                        >{deal}
                                                                        </Select>
                                                                            :
                                                                            <>{displayData?.dealId ? <span className='user-info_image ListNavigate'
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => displayData?.dealId && ViewDetailPage(displayData?.dealId, "DEAL")}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(displayData?.dealId, "DEAL");
                                                                                    }
                                                                                }}
                                                                            >{displayData?.dealId && (
                                                                                displayData?.dealProfile !== null && displayData?.dealProfile
                                                                                    !== undefined && displayData?.dealProfile !== "" ?
                                                                                    <figure>
                                                                                        <img style={{ width: "30px", height: "30px" }} src={displayData?.dealProfile} alt="" />
                                                                                    </figure>
                                                                                    :
                                                                                    <span className='list_span_Tag DealIcon'>
                                                                                        {displayData?.dealName?.slice(0, 1).toUpperCase()}
                                                                                    </span>)
                                                                                }{displayData?.dealId && (
                                                                                    <figcaption>
                                                                                        {displayData?.dealName}
                                                                                    </figcaption>)}</span> : <></>}</>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Contact Name" name="contact" id="contact" rules={edit ? [{ required: true, message: 'Please select contact' }] : [{ required: false }]}>
                                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Contact Name"
                                                                            showSearch optionLabelProp="label"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                            onChange={(value) => onChangeContact(value)}
                                                                        >
                                                                            {contact}
                                                                        </Select> : <span className='user-info_image ListNavigate'
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            onClick={() => displayData?.caseCreater && ViewDetailPage(displayData?.caseCreater, "CONTACT")}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    ViewDetailPage(displayData?.caseCreater, "CONTACT");
                                                                                }
                                                                            }}
                                                                        >{displayData?.conatctId && (
                                                                            displayData?.contactprofilePic !== null && displayData?.contactprofilePic
                                                                                !== undefined && displayData?.contactprofilePic !== "" ?
                                                                                <figure>
                                                                                    <img style={{ width: "30px", height: "30px" }} src={displayData?.contactprofilePic} alt="" />
                                                                                </figure>
                                                                                :
                                                                                <span className='list_span_Tag ContactIcon'>
                                                                                    {displayData?.contactFirstName?.slice(0, 1).toUpperCase()}
                                                                                </span>)
                                                                            }{displayData?.conatctId && (
                                                                                <figcaption>
                                                                                    {`${displayData?.contactFirstName} ${displayData?.contactLastName}`}
                                                                                </figcaption>)}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Sales Commision (${defaultCurrency?.currency})`} name="salescommision" id="salescommision" rules={[{
                                                                        validator: async (_, value) => {
                                                                            if (value === undefined || value === null || value === '') {
                                                                                return Promise.resolve();
                                                                            }
                                                                            if (value?.toString()?.length > 25) {
                                                                                return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                            }
                                                                            // Strict numeric check (digits with optional 1 dot)
                                                                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                            if (!basicNumberCheck.test(value)) {
                                                                                return Promise.reject(new Error('Please enter a valid number'));
                                                                            }

                                                                            // Check decimal places (must be ≤ 2)
                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${defaultCurrency?.decimalOfCurrency}})?$`);
                                                                            if (!decimalRegex.test(value)) {
                                                                                return Promise.reject(
                                                                                    new Error(`Only up to ${defaultCurrency?.decimalOfCurrency} decimal place${defaultCurrency?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        }

                                                                    }]}>
                                                                        {edit ? <Input placeholder="Enter Sales Commision" onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ salescommision: 0 });
                                                                            }
                                                                        }} prefix={defaultCurrency?.symbol} /> :
                                                                            <span>{displayData?.salesCommision && defaultCurrency?.symbol} {displayData?.salesCommision}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Excise Duty (${defaultCurrency?.currency})`} name="exciseduty" id="exciseduty" rules={[{
                                                                        validator: async (_, value) => {
                                                                            if (value === undefined || value === null || value === '') {
                                                                                return Promise.resolve();
                                                                            }
                                                                            if (value?.toString()?.length > 25) {
                                                                                return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                            }
                                                                            // Strict numeric check (digits with optional 1 dot)
                                                                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                            if (!basicNumberCheck.test(value)) {
                                                                                return Promise.reject(new Error('Please enter a valid number'));
                                                                            }

                                                                            // Check decimal places (must be ≤ 2)
                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${defaultCurrency?.decimalOfCurrency}})?$`);
                                                                            if (!decimalRegex.test(value)) {
                                                                                return Promise.reject(
                                                                                    new Error(`Only up to ${defaultCurrency?.decimalOfCurrency} decimal place${defaultCurrency?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        }

                                                                    }]}>
                                                                        {edit ? <Input placeholder="Enter Excise Duty" onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ exciseduty: 0 });
                                                                            }
                                                                        }} prefix={defaultCurrency?.symbol} /> :
                                                                            <span>{displayData?.exciseDuty && defaultCurrency?.symbol} {displayData?.exciseDuty}</span>
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Invoice Date" name="invoicedate" id="invoicedate" dependencies={["date"]} rules={edit ? [{ required: true, message: 'Please select invoice date' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const endDate = getFieldValue("date");
                                                                            if (!value || !endDate || value <= endDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Invoice date cannot be after due date"));
                                                                        },
                                                                    })
                                                                    ] : [{ required: false }]}>
                                                                        {edit ? <DatePicker allowClear={false}
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            onChange={invoiceDateChange}
                                                                            disabledDate={disabledDate}
                                                                        /> : <span >
                                                                            {displayData !== undefined && displayData.invoiceDate ? moment(displayData !== undefined && displayData.invoiceDate).format(profile.dateFormate) : (displayData !== undefined && displayData.invoiceDate && moment(displayData !== undefined && displayData.invoiceDate).format("YYYY-MM-DD"))}
                                                                        </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Due Date" name="date" id="date" dependencies={["invoicedate"]} rules={edit ? [{ required: true, message: 'Please select due date' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const startDate = getFieldValue("invoicedate");
                                                                            if (!value || !startDate || value >= startDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Due date cannot be before invoice date"));
                                                                        },
                                                                    })
                                                                    ] : [{ required: false }]}>
                                                                        {edit ? <DatePicker allowClear={false}
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            onChange={DueDateChange}
                                                                            disabledDate={disabledDate} /> : <span >
                                                                            {displayData !== undefined && displayData.dueDate ? moment(displayData !== undefined && displayData.dueDate).format(profile.dateFormate) : (displayData !== undefined && displayData.dueDate && moment(displayData !== undefined && displayData.dueDate).format("YYYY-MM-DD"))}
                                                                        </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {InvoiceStatus === "Paid" &&
                                                                <>
                                                                    <Heading as="h5">Payment details </Heading>
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Payment Status" name="paymentStatus" id="paymentStatus" rules={edit ? [{ required: true, message: 'Please select payment status' }] : [{ required: false }]} >
                                                                                {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Enter Select Payment Status" onChange={(value) => handlePaymentchange(value)}>
                                                                                    <Option value="Partially Paid">Partially Paid</Option>
                                                                                    <Option value="Fully Paid">Fully Paid</Option>
                                                                                </Select> :
                                                                                    <span>{displayData?.paymentStatus}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label={`Paid Amount (${defaultCurrency?.currency})`} name="paidAmount" id="paidAmount" rules={edit ? [{
                                                                                required: true,
                                                                                transform: (value) => value?.trim(), message: 'Please enter paid amount'
                                                                            },
                                                                            {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    if (value?.toString()?.length > 25) {
                                                                                        return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${defaultCurrency?.decimalOfCurrency}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${defaultCurrency?.decimalOfCurrency} decimal place${defaultCurrency?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                }

                                                                            }] : [{ required: false }]
                                                                            } >
                                                                                {edit ? <Input placeholder="Enter Paid Amount" onBlur={(e) => {
                                                                                    if (e.target.value === '') {
                                                                                        form.setFieldsValue({ paidAmount: 0 });
                                                                                    }
                                                                                }} prefix={defaultCurrency?.symbol} disabled={paymentStatus === "Fully Paid"} onChange={(e) => handlePaidChange(e.target.value)} /> :
                                                                                    <span> {displayData?.paidAmount && defaultCurrency?.symbol} {displayData?.paidAmount}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label={`Balance Amount (${defaultCurrency?.currency})`} name="balanceAmount" id="balanceAmount" rules={edit ? [{
                                                                                required: true,
                                                                                transform: (value) => value?.trim(), message: 'Please enter balance amount'
                                                                            }, {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    if (value?.toString()?.length > 25) {
                                                                                        return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${defaultCurrency?.decimalOfCurrency}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${defaultCurrency?.decimalOfCurrency} decimal place${defaultCurrency?.decimalOfCurrency > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }] : [{ required: false }]} >
                                                                                {edit ? <Input placeholder="Enter Balance Amount" onBlur={(e) => {
                                                                                    if (e.target.value === '') {
                                                                                        form.setFieldsValue({ balanceAmount: 0 });
                                                                                    }
                                                                                }} prefix={defaultCurrency?.symbol} disabled /> :
                                                                                    <span>{displayData?.balanceAmount && defaultCurrency?.symbol} {displayData?.balanceAmount}</span>
                                                                                }
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </>}
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8}>
                                                                    <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Billing Address</Heading>
                                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>

                                                                        <Col span={24} >
                                                                            {Billing ?
                                                                                <div className="addressCard" title="Edit Address"
                                                                                    style={{ cursor: edit ? "pointer" : "default" }}
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    onClick={() => edit ? addressPopup("Update", "Billing") : undefined}
                                                                                    onKeyDown={(event) => {
                                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                                            addressPopup("Update", "Billing")
                                                                                        }
                                                                                    }}>
                                                                                    <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                        <div style={{ fontSize: "18px", fontWeight: "600" }}>{`${billingAddress?.name} (${accountJsonData?.registration_number || accountJsonData?.account_number})`}</div>
                                                                                        <div>{billingAddress?.street}{billingAddress?.city && `, ${billingAddress?.city}`}</div>
                                                                                        {(billingAddress?.state || billingAddress?.zipcode) && (
                                                                                            <div>
                                                                                                {billingAddress?.state}
                                                                                                {billingAddress?.state && billingAddress?.zipcode ? ", " : ""}
                                                                                                {billingAddress?.zipcode}
                                                                                            </div>
                                                                                        )}
                                                                                        <div>{billingAddress?.country}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.email}>Email  : {billingAddress?.email}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.mobile}>Mobile : {billingAddress?.mobile}</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                edit &&
                                                                                <div className="addressCard" style={{
                                                                                    fontSize: 50,
                                                                                    width: "80%",
                                                                                    height: "175px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>
                                                                                    <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => addressPopup("Create", "Billing")} />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row >
                                                                </Col>
                                                                <Col span={8}>
                                                                    <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Shipping Address</Heading>
                                                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>

                                                                        <Col span={24}>
                                                                            {Billing && Shipping ?
                                                                                <div className="addressCard" title="Edit Address"
                                                                                    role="button" style={{ cursor: edit ? "pointer" : "default" }}
                                                                                    tabIndex={0}
                                                                                    onClick={() => edit ? addressPopup("Update", "Shipping") : undefined}
                                                                                    onKeyDown={(event) => {
                                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                                            addressPopup("Update", "Shipping")
                                                                                        }
                                                                                    }}>
                                                                                    <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                        <div style={{ fontSize: "18px", fontWeight: "600" }}>{`${shipingAddress?.name} (${accountJsonData?.registration_number || accountJsonData?.account_number})`}</div>
                                                                                        <div>{shipingAddress?.street}{shipingAddress?.city && `, ${shipingAddress?.city}`}</div>
                                                                                        {(shipingAddress?.state || shipingAddress?.zipcode) && (
                                                                                            <div>
                                                                                                {shipingAddress?.state}
                                                                                                {shipingAddress?.state && shipingAddress?.zipcode ? ", " : ""}
                                                                                                {shipingAddress?.zipcode}
                                                                                            </div>
                                                                                        )}<div>{shipingAddress?.country}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.email}>Email  : {shipingAddress?.email}</div>
                                                                                        <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.mobile}>Mobile : {shipingAddress?.mobile}</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                edit &&
                                                                                <div className="addressCard" style={{
                                                                                    fontSize: 50,
                                                                                    width: "80%",
                                                                                    height: "175px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>  <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => Billing ? addressPopup("Create", "Shipping") : undefined} />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Invoice Items</Heading>
                                                            {isCustomMode ? <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={24} >
                                                                    <CustomInvoiceBuilder currencySettings={defaultCurrency} profile={profile} onChange={onChangeNewTableData} items={items} itemTableHeader={itemTableHeader} />
                                                                </Col> </Row> : items?.length > 0 ? <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    <div className="table-bordered leaderboard-table table-responsive QSITable" style={{ width: '100%' }}>
                                                                        <Table dataSource={items}
                                                                            columns={ProductColumns}
                                                                            // columns={ProductColumns.slice(0, -1)}
                                                                            // columns={disableFileds ? ProductColumns : editableColumns} 
                                                                            pagination={false} />
                                                                    </div>
                                                                </Row> : <Row gutter={30} style={{ margin: "20px 0px" }} />}
                                                            {(isCustomMode || items?.length > 0) ? <Row justify="end" style={{ marginBottom: 20 }}>
                                                                <Col xxl={10} xl={10} lg={10} md={10} sm={18} xs={24} offset={0}>
                                                                    <OrderSummary style={{ maxWidth: 450 }}>
                                                                        <div className="invoice-summary-inner" >
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Subtotal" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item label={`${defaultCurrency?.symbol} ${Number(total)?.toLocaleString()}`} />
                                                                                </Col>
                                                                            </Row>
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Discount" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item>
                                                                                        <Input placeholder="Discount" prefix="%" value={dealDiscount} disabled={!edit}
                                                                                            onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (inputValue?.toString()?.length > 25) {
                                                                                                    message.error('Maximum 25 characters allowed');
                                                                                                    return;
                                                                                                }
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                const num = Number(inputValue);
                                                                                                if (inputValue && (num < 0 || num > 100)) {
                                                                                                    message.error('Percentage must be between 0 and 100');
                                                                                                    return;
                                                                                                }
                                                                                                setDealDiscount(inputValue);
                                                                                            }} />
                                                                                    </Form.Item></Col>
                                                                            </Row>
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Tax" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item>
                                                                                        <Input placeholder="Tax" prefix="%" value={tax} disabled={!edit} onChange={(e) => {
                                                                                            const inputValue = e.target.value;
                                                                                            const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                            const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                            if (inputValue?.toString()?.length > 25) {
                                                                                                message.error('Maximum 25 characters allowed');
                                                                                                return;
                                                                                            }
                                                                                            if (!basicNumberCheck) {
                                                                                                message.error('Please enter a valid number');
                                                                                                return;
                                                                                            }
                                                                                            if (inputValue === ".") {
                                                                                                message.error('Please enter a valid number');
                                                                                                return;
                                                                                            }
                                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                            if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                return;
                                                                                            }
                                                                                            const num = Number(inputValue);
                                                                                            if (inputValue && (num < 0 || num > 100)) {
                                                                                                message.error('Percentage must be between 0 and 100');
                                                                                                return;
                                                                                            }
                                                                                            setTax(inputValue);
                                                                                        }} />
                                                                                    </Form.Item></Col>
                                                                            </Row>
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Adjustment" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item>  <Input placeholder="Adjustment" disabled={!edit} prefix={defaultCurrency?.symbol} value={adjustment} onChange={(e) => {
                                                                                        const inputValue = e.target.value;
                                                                                        const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                        const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                        if (inputValue?.toString()?.length > 25) {
                                                                                            message.error('Maximum 25 characters allowed');
                                                                                            return;
                                                                                        }
                                                                                        if (!basicNumberCheck) {
                                                                                            message.error('Please enter a valid number');
                                                                                            return;
                                                                                        }
                                                                                        if (inputValue === ".") {
                                                                                            message.error('Please enter a valid number');
                                                                                            return;
                                                                                        }
                                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                        if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                            message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                            return;
                                                                                        }
                                                                                        setAdjustment(inputValue)
                                                                                    }} />
                                                                                    </Form.Item></Col>
                                                                            </Row>
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Shipping/Handling" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item> <Input placeholder="Shipping/Handling" disabled={!edit} prefix={defaultCurrency?.symbol} value={shippingss} onChange={(e) => {
                                                                                        const inputValue = e.target.value;
                                                                                        const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                        const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                        if (inputValue?.toString()?.length > 25) {
                                                                                            message.error('Maximum 25 characters allowed');
                                                                                            return;
                                                                                        }
                                                                                        if (!basicNumberCheck) {
                                                                                            message.error('Please enter a valid number');
                                                                                            return;
                                                                                        }
                                                                                        if (inputValue === ".") {
                                                                                            message.error('Please enter a valid number');
                                                                                            return;
                                                                                        }
                                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                        if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                            message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                            return;
                                                                                        }
                                                                                        setShipping(inputValue)
                                                                                    }} />
                                                                                    </Form.Item></Col>
                                                                            </Row>
                                                                            <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                <Col lg={8} md={9} xs={24}>
                                                                                    <Form.Item label="Grand Total" />
                                                                                </Col>
                                                                                <Col lg={16} md={15} xs={24}>
                                                                                    <Form.Item label={`${defaultCurrency?.symbol} ${Number(grandTotal)?.toLocaleString()}`} />
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </OrderSummary>
                                                                </Col>
                                                            </Row> : <></>}
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Notes">
                                                                        {edit ? <TinyMCEEditor
                                                                            placeholder="Enter note"
                                                                            content={content3}
                                                                            setContent={handleChange3}
                                                                            edit
                                                                            page="TextBoxs"
                                                                            height={150}
                                                                            selectedEntity="A3"
                                                                        /> :
                                                                            <CustomHtmlParser html={content3} key={3} page="TextBoxs" />}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Terms and Condition">
                                                                      {edit ? <TinyMCEEditor
                                                                            placeholder="Enter Terms and Condition"
                                                                            content={content1}
                                                                            setContent={handleChange1}
                                                                            edit
                                                                            page="TextBoxs"
                                                                            height={150}
                                                                            selectedEntity="A"
                                                                        /> :
                                                                            <CustomHtmlParser html={content1} key={1} page="TextBoxs" />}
                                                                      </Form.Item>
                                                                </Col>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Description">
                                                                      {edit ? <TinyMCEEditor
                                                                            placeholder="Enter Description"
                                                                            content={content2}
                                                                            setContent={handleChange2}
                                                                            edit
                                                                            page="TextBoxs"
                                                                            height={150}
                                                                            selectedEntity="A2"
                                                                        /> :
                                                                            <CustomHtmlParser html={content2} key={2} page="TextBoxs" />}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Invoice" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="invoice" entity="EntityPages" toId={[conatactDetails?.email]}
                AllData={{
                    accountJsonData,
                    data: displayData,
                    companyData,
                    tableItem: items,
                    tableColum: ProductColumns.slice(0, -1),
                    defaultCurrency, Calculation: { total, dealDiscount, tax, adjustment, shippingss, grandTotal }, theme: pdfTheme
                }} SubjectData={SubjectData} MailContent={MailContent} attachFile={attachFile} updateStatus={updateStatus} updateId={invoiceId} invoiceToken={UrlId ? UrlId[1] : null} />
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {popupOpen && <AddressPopup accountId={accountId} confirmPopup={popupOpen} setConfirmPopup={setPopupOpen} popupType={popupType} popupContent={popupContent} billingAddress={billingAddress} setBillingAddress={setBillingAddress} shipingAddress={shipingAddress} setShipingAddress={setShipingAddress} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    setCloneId: PropTypes.func.isRequired,
    cloneId: PropTypes.number.isRequired,
};

export default AddNew;